// extracted by mini-css-extract-plugin
module.exports = {"core":"ProfileCard-core-1X1eL","box":"ProfileCard-box-31Ssr","label":"ProfileCard-label-3jY_X","upload":"ProfileCard-upload-1Qhcw","uploadInput":"ProfileCard-uploadInput-3WejP"};